<template>
  <div class="training">
    <spreadsheet :opts="opts"/>
    <el-dialog title="文件预览" :fullscreen="true" :close-on-click-modal="false" :lock-scroll="true" :visible.sync="showPreview">
      <iframe :src="prevLink" width="100%" height="100%"></iframe>
      <!-- <div ref="preview" id="preview"></div>
      <preview ref="preview"></preview>-->
    </el-dialog>
  </div>
</template>
<script>
// Generated by CoffeeScript 2.3.0
import { PDFObject } from '../../commons'

let m

export default (m = {
  data: function() {
    return {
      pdfOpts: {
        height: '1200px',
        pdfOpenParams: {
          scrollbars: '0',
          toolbar: '0',
          statusbar: '0',
        },
      },
      showPreview: false,
      prevLink: '',
      opts: {
        tableName: 'training',
        displayName: '培训系统',
        columns: [
          {
            label: '名称',
            type: 'link',
            width: 500,
            display: item => item['名称'],
            handler: item => {
              this.$message({
                message: this.$createElement('p', null, [
                  this.$createElement(
                    'i',
                    {
                      class: 'el-icon-loading',
                    },
                    '',
                  ),
                  this.$createElement('span', null, '请等待..'),
                ]),
                duation: 5000,
              })
              return app.api
                .findOne({
                  tableName: 'training',
                  _id: item._id,
                })
                .then(training => {
                  let clickCount
                  if (training['点击量']) {
                    clickCount = training['点击量'] + 1
                  } else {
                    clickCount = 1
                  }
                  return app.api
                    .update({
                      tableName: 'training',
                      _id: training._id,
                      data: {
                        点击量: clickCount,
                      },
                    })
                    .then(() => {
                      let reg
                      reg = new RegExp('(.doc|.docx|.ppt|.pptx|.xls|.xlsx|.pdf)$')
                      if (!reg.test(item['文件路径'])) {
                        window.open(`${host}/training/${item['文件路径']}`)
                        return false
                      } else {
                        return app
                          .service('misc')
                          .prevTraining({ target: item['文件路径'] })
                          .then(res => {
                            if (res.status === 'success') {
                              this.prevLink = res.data.url
                              this.showPreview = true
                              // this.$nextTick(() => {
                              //   return PDFObject.embed(this.prevlink, '#preview', this.pdfOpts)
                              // })
                              // return this.$nextTick(() => {
                              //   return this.$refs['preview'].click()
                              // })
                            } else {
                              console.error(res.msg)
                            }
                          })
                          .catch(e => console.log('Filetype not supported for preview.'))
                      }
                    })
                })
            },
          },
          {
            // window.open "#{host}/training/#{item['文件路径']}"
            label: '关键字',
          },
        ],
        sortby: {
          排序: -1,
          点击量: -1,
        },
        fields: 'all',
        filter: {
          权限: {
            $lte: app.user['培训权限'],
          },
        },
        defaultItem: {
          permissions: {
            所有人: '读取',
          },
        },
        maxItem: 1000,
        showPagination: true,
        expandable: true,
        creatable: true,
        trackable: true,
        editable: false,
        actionbar: false,
      },
    }
  },
})
</script>
<style>
.training .is-fullscreen .el-dialog__body {
  position: absolute;
  top: 50px;
  bottom: 0;
  width: 100%;
}
</style>




